// extracted by mini-css-extract-plugin
export var closedMsg = "Maintenance_closedMsg__sgzUa";
export var faExclamationCircle = "Maintenance_faExclamationCircle__epHkz fontawesome_min_fa-exclamation-circle__ysrJ1";
export var fal = "Maintenance_fal__DvhU5 fa-light_min_fal__ABekM fontawesome_min_fal__-+-vD";
export var header = "Maintenance_header__tQpdB CustomizePanel_header__Etr2+";
export var icon = "Maintenance_icon__JKP+P fontawesome_min_fal__-+-vD fontawesome_min_fa-exclamation-circle__ysrJ1";
export var maintenanceHeader = "Maintenance_maintenanceHeader__fxxLY";
export var maintenanceText = "Maintenance_maintenanceText__1D6Wy";
export var mobile = "Maintenance_mobile__rl5W1";
export var status = "Maintenance_status__ypvlm CustomizePanel_status__ZrjPI";
export var statusContainer = "Maintenance_statusContainer__Vbr5J";
export var statusLight = "Maintenance_statusLight__xv+8S CustomizePanel_statusLight__s5oRQ";
export var textContainer = "Maintenance_textContainer__EZMBX";
export var title = "Maintenance_title__6+Ra6 CustomizePanel_title__+sb0o";